var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c(
        "div",
        { style: _vm.s.body },
        [
          _c("span", { staticClass: "bg-img" }),
          _vm.inviteeCode && +_vm.inviteeCode !== 0
            ? _c("div", [
                _c("div", { staticClass: "invite-code" }, [
                  _vm._v(
                    _vm._s(_vm.$t("assets.invite.invited")) +
                      _vm._s(this.inviteeCode)
                  )
                ])
              ])
            : _c(
                "div",
                { staticClass: "__row" },
                [
                  _c("div", { staticClass: "__row_t" }, [
                    _vm._v(_vm._s(_vm.$t("assets.invite.codeLable"))),
                    _vm.formatErr
                      ? _c("div", { staticClass: "__err" }, [
                          _vm._v(_vm._s(_vm.$t("assets.invite.formatErr")))
                        ])
                      : _vm._e()
                  ]),
                  _c("vite-input", {
                    model: {
                      value: _vm.code,
                      callback: function($$v) {
                        _vm.code = $$v
                      },
                      expression: "code"
                    }
                  })
                ],
                1
              ),
          _c("div", { staticClass: "__row __row_t" }, [
            _vm._v(_vm._s(_vm.$t("assets.invite.inviteRule")))
          ]),
          _vm._l(_vm.$t("assets.invite.receiveRuleItems"), function(i, j) {
            return _c("div", { key: j, staticClass: "__hint" }, [
              _c("span", { domProps: { innerHTML: _vm._s(i) } })
            ])
          })
        ],
        2
      ),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }